module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_135514-314970537.23074e7e.jpg";